import LandingPageWrapper from "./LandingPageWrapper";
export default LandingPageWrapper;
